export function FieldsSchema(formData: any) {
  return (
    [
      {
        fieldName: 'ApplicationTitle',
        initialValue: formData?.ApplicationTitle || '',
        fieldLabel: 'Application Title',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'ApplicantName',
        initialValue: formData?.ApplicantName || '',
        fieldLabel: 'Applicant Name',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'ApplicantType',
        initialValue: formData?.ApplicantType || '',
        fieldLabel: 'Applicant Type',
        fieldType: 'select',
        options: ['Owner', 'Agent', 'Contractor', 'Architect', 'Tenant/Lease'],
        required: true
      },
      // {
      //   fieldName: 'ApplicationType',
      //   initialValue: formData?.ApplicationType || '',
      //   fieldLabel: 'Application Type',
      //   fieldType: 'select',
      //   options: ['New Build', 'Demolition', 'Renovation/Existing Building'],
      //   required: true
      // },
      {
        fieldName: 'PurposeType',
        initialValue: formData?.PurposeType || [],
        fieldLabel: 'Purpose Type',
        fieldType: 'multiselect',
        options: ['New Build', 'Demolition', 'Renovation/Existing Building'],
        required: true,
        multiSelect: true,
      },
      {
        fieldName: 'PropertyUseType',
        initialValue: formData?.PropertyUseType || '',
        fieldLabel: 'Property Use Type',
        fieldType: 'select',
        options: [
          'Residential',
          'Commercial',
          'Industrial',
          'Agriculture',
          'Mixed-use'
        ],
        required: true
      },
      {
        fieldName: 'PropertyType',
        initialValue: formData?.PropertyType || '',
        fieldLabel: 'Property Type',
        fieldType: 'select',
        options: [
          'Private',
          'Corporate',
          'Public',
          'Partnership',
          'Trust or estate'
        ],
        required: true
      },
      {
        fieldName: 'ProjectContactName',
        initialValue: formData?.ProjectContactName || '',
        fieldLabel: 'Project Contact Name',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'ProjectContactPhone',
        initialValue: formData?.ProjectContactPhone || '',
        fieldLabel: 'Project Phone Number',
        fieldType: 'mobile',
        required: true
      },
      {
        fieldName: 'BlockLot',
        initialValue: formData?.BlockLot || '',
        fieldLabel: 'Block Lot',
        fieldType: 'autocomplete',
        options: [],
        required: true
      },
      {
        fieldName: 'ProjectLocation',
        initialValue: formData?.ProjectLocation || '',
        fieldLabel: 'Project Location/Property Address',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'AuthorizedEmail',
        initialValue: formData?.AuthorizedEmail || '',
        fieldLabel: 'Authorized Email Address',
        fieldType: 'email',
        required: true
      },
      {
        fieldName: 'ConstructionSchedule',
        initialValue: formData?.ConstructionSchedule || '',
        fieldLabel: 'Construction Schedule',
        fieldType: 'date',
        required: true
      },
      {
        fieldName: 'DescribeUse',
        initialValue: formData?.DescribeUse || '',
        fieldLabel: 'Describe Use',
        fieldType: 'note',
        required: true
      },
      {
        fieldName: 'OwnersName',
        initialValue: formData?.OwnersName || '',
        fieldLabel: 'Owner Name',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'OwnerMobileNumber',
        initialValue: formData?.OwnerMobileNumber || '',
        fieldLabel: 'Owner Mobile Number',
        fieldType: 'mobile',
        required: true
      },
      {
        fieldName: 'AgentsLicenseNumber',
        initialValue: formData?.AgentsLicenseNumber || '',
        fieldLabel: "Agent's License Number",
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'CompanyName',
        initialValue: formData?.CompanyName || '',
        fieldLabel: 'Company Name',
        fieldType: 'text',
        required: false
      },
      {
        fieldName: 'ContractorLicenseNumber',
        initialValue: formData?.ContractorLicenseNumber || '',
        fieldLabel: 'Contractor License Number',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'CompanyName',
        initialValue: formData?.CompanyName || '',
        fieldLabel: 'Company Name',
        fieldType: 'text',
        required: false
      },
      {
        fieldName: 'ArchitectLicenseNumber',
        initialValue: formData?.ArchitectLicenseNumber || '',
        fieldLabel: 'Architect License Number',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'TenantName',
        initialValue: formData?.TenantName || '',
        fieldLabel: "Tenant's Name",
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'TenantEmail',
        initialValue: formData?.TenantEmail || '',
        fieldLabel: "Tenant's Email",
        fieldType: 'email',
        required: true
      },
      {
        fieldName: 'TenantPhone',
        initialValue: formData?.TenantPhone || '',
        fieldLabel: "Tenant's Phone Number",
        fieldType: 'mobile',
        required: true
      },
      {
        fieldName: 'NumberOfUnits',
        initialValue: formData?.NumberOfUnits || '',
        fieldLabel: 'Number of Units',
        fieldType: 'number',
        required: true
      },
      {
        fieldName: 'NumberOfBedrooms',
        initialValue: formData?.NumberOfBedrooms || '',
        fieldLabel: 'Number of Bedrooms',
        fieldType: 'number',
        required: true
      },
      {
        fieldName: 'BusinessOccupancyClassification',
        initialValue: formData?.BusinessOccupancyClassification || '',
        fieldLabel: 'Business Occupancy Classification',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'ParkingRequirements',
        initialValue: formData?.ParkingRequirements || '',
        fieldLabel: 'Parking Requirements',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'IndustrialEquipmentSpecifications',
        initialValue: formData?.IndustrialEquipmentSpecifications || '',
        fieldLabel: 'Industrial Equipment Specifications',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'AgriculturalEquipmentSpecifications',
        initialValue: formData?.AgriculturalEquipmentSpecifications || '',
        fieldLabel: 'Agricultural Equipment Specifications',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'LandUseAndCropPlan',
        initialValue: formData?.LandUseAndCropPlan || '',
        fieldLabel: 'Land Use and Crop Plan',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'ResidentialUnitBreakdown',
        initialValue: formData?.ResidentialUnitBreakdown || '',
        fieldLabel: 'Residential Unit Breakdown',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'CommercialUnitBreakdown',
        initialValue: formData?.CommercialUnitBreakdown || '',
        fieldLabel: 'Commercial Unit Breakdown',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'SharedFacilityManagementPlan',
        initialValue: formData?.SharedFacilityManagementPlan || '',
        fieldLabel: 'Shared Facility Management Plan',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'PrivatePropertyUsePlan',
        initialValue: formData?.PrivatePropertyUsePlan || '',
        fieldLabel: 'Private Property Use Plan',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'PropertyTaxInformation',
        initialValue: formData?.PropertyTaxInformation || '',
        fieldLabel: 'Property Tax Information',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'CorporateEntityName',
        initialValue: formData?.CorporateEntityName || '',
        fieldLabel: 'Corporate Entity Name',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'BusinessRegistrationNumber',
        initialValue: formData?.BusinessRegistrationNumber || '',
        fieldLabel: 'Business Registration Number',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'AuthorizedRepresentative',
        initialValue: formData?.AuthorizedRepresentative || '',
        fieldLabel: 'Authorized Representative',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'CorporateTaxInformation',
        initialValue: formData?.CorporateTaxInformation || '',
        fieldLabel: 'Corporate Tax Information',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'GovernmentAgencyName',
        initialValue: formData?.GovernmentAgencyName || '',
        fieldLabel: 'Government Agency Name',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'PartnerNames',
        initialValue: formData?.PartnerNames || '',
        fieldLabel: 'Partner Names',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'RegisteredPartnershipNumber',
        initialValue: formData?.RegisteredPartnershipNumber || '',
        fieldLabel: 'Registered Partnership Number',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'PartnershipTaxInformation',
        initialValue: formData?.PartnershipTaxInformation || '',
        fieldLabel: 'Partnership Tax Information',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'TrusteeName',
        initialValue: formData?.TrusteeName || '',
        fieldLabel: 'Trustee Name',
        fieldType: 'text',
        required: true
      },

      {
        fieldName: 'BeneficiariesInformation',
        initialValue: formData?.BeneficiariesInformation || '',
        fieldLabel: 'Beneficiaries Information',
        fieldType: 'text',
        required: true
      },
      {
        fieldName: 'EstateTaxInformation',
        initialValue: formData?.EstateTaxInformation || '',
        fieldLabel: 'Estate Tax Information',
        fieldType: 'text',
        required: true
      }
    ]
  )
}
